import { uuid } from '@elfsight/lib-utils';
import type { WorkingHours } from '@elfsight/widget-business-hours/common';
import type { LocationCardProps } from './location-card-types';

const makeDefaultWorkingHours = (): WorkingHours[] => [
  {
    id: uuid(),
    timeRange: ['8:00', '17:00']
  }
];

export const locationCardDefaultProps: LocationCardProps = {
  dayMondayOpen: true,
  dayMondayHours: makeDefaultWorkingHours(),
  dayTuesdayOpen: true,
  dayTuesdayHours: makeDefaultWorkingHours(),
  dayWednesdayOpen: true,
  dayWednesdayHours: makeDefaultWorkingHours(),
  dayThursdayOpen: true,
  dayThursdayHours: makeDefaultWorkingHours(),
  dayFridayOpen: true,
  dayFridayHours: makeDefaultWorkingHours(),
  daySaturdayOpen: false,
  daySaturdayHours: makeDefaultWorkingHours(),
  daySundayOpen: false,
  daySundayHours: makeDefaultWorkingHours(),

  specialIntervals: [],

  businessName: '',
  businessAbout: '',
  businessAboutShortened: true,
  businessLogo: undefined,
  businessLogoStyle: 'default',
  businessLogoColor: '#fff',

  businessLogoSize: 72,

  contactsShowLabels: false,
  contactsShowIcons: true,
  contactsPhone: '',
  contactsWhatsApp: '',
  contactsInstagram: '',
  contactsEmail: '',
  contactsAddress: '',
  contactsWebsite: '',
  locationPhotoImage: undefined,

  locationPhotoPosition: 'left',
  locationPhotoHorizontalAspectRatio: 0.5,
  locationPhotoVerticalAspectRatio: 2,
  locationPhotoDisplayMobile: true,
  locationPhotoMobilePosition: 'top',
  locationLabels: [],

  ctaButtons: [],

  businessHoursDisplay: 'onPage',

  alignment: 'center',
  background: {
    type: 'color',
    color: 'transparent'
  },
  horizontalPadding: 32,
  verticalPadding: 32,

  textColor: '#1B1B1B',
  iconsColor: 'rgba(17, 17, 17, 0.7)',
  openStatusColor: '#0E8B25',
  closedStatusColor: '#B82D2D',
  closedSoonStatusColor: '#FF7800',
  accentColor: '#0076FB',
  platformCtaButtonColor: 'native',

  textStyle: {
    fontSize: 15
  },

  businessNameStyle: {
    fontSize: 32,
    fontStyle: 'normal',
    fontWeight: 'bold'
  },

  ctaButtonsStyle: 'contain',
  ctaButtonsRadius: 8,
  ctaButtonsSize: { value: 14, customValue: 14 },

  timeZone: undefined,
  dayMonthFormat: 'full',
  language: undefined,

  footerOffset: 32
};
